export const searchItems = [
  {
    label: '关键字',
    type: 'input',
    decorator: ['name'],
    placeholder: '请输入对象名称'
  }
]
